module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', [_c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showErrorStatusChange),
      callback: function($$v) {
        _vm.showErrorStatusChange = $$v
      },
      expression: "showErrorStatusChange"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_ERROR', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_STATUS_WAS_NOT_CHANGED', this.lang)))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_CENTER_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-client-table', {
    ref: "centerTable",
    attrs: {
      "data": _vm.centersData,
      "columns": _vm.centersColumns,
      "options": _vm.centersOptions
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-minus-circle': props.row.status === '1', 'fa-check-circle': props.row.status === '0'
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "editCenter",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.centerRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": _vm.$t('LNG_NEW_CENTER', this.lang)
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.newCenterModal),
      callback: function($$v) {
        _vm.newCenterModal = $$v
      },
      expression: "newCenterModal"
    }
  }, [(_vm.showCenterUpdateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n         " + _vm._s(this.updateCenterErrorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-input', {
    ref: "centerName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME_CENTER', this.lang)
    },
    model: {
      value: (_vm.centerName),
      callback: function($$v) {
        _vm.centerName = $$v
      },
      expression: "centerName"
    }
  }), _vm._v(" "), _c('b-input', {
    ref: "grade",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": _vm.$t('LNG_MAX_GRADE', this.lang)
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitNewCenterModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createUpdateNewCenter($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnSaveText))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af66f892"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/managementCenter.vue
// module id = 883
// module chunks = 1